import { createContext } from 'react';
import { DEFAULT_LANGUAGE, LanguageContextData, TextData } from './types';

export const textValues = require('./texts.json') as TextData;
export const LanguageContext = createContext<LanguageContextData>({ language: DEFAULT_LANGUAGE, setLanguage: (language) => {} });